import {
  addMymeToLibraryAPI,
  getLibraryMymesAPI,
  GETLibraryMymesResponse,
  GETLibrarySearchParams,
  getMymeParticipationAPI,
  GETMymeTableOfContents,
  markMymeAsOpenedAPI,
  POSTAddMymeToLibraryReqBody,
  POSTAddMymeToLibraryResponse,
  POSTMarkMymeAsOpenedResponse,
  removeMymeFromLibraryAPI,
  searchLibraryMymesAPI
} from '@myme/api';
import {
  MymeParticipation,
  Pagination,
  sendRequest,
  transformArrayToSearchParams,
  transformPaginationToSearchParams,
  UUID
} from '@myme/utils';

const getMymeIdRecord = (mymeId: UUID) => ({
  key: 'mymeId',
  value: mymeId
});

/* **** DELETE **** /user-library/:mymeId */
export const removeMymeFromLibrary = async (mymeId: UUID) =>
  sendRequest<null, null>(removeMymeFromLibraryAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** GET **** /user-library */
export const getLibraryMymes = async (pagination: Pagination) =>
  sendRequest<GETLibraryMymesResponse, null>(getLibraryMymesAPI, {
    queryStringParams: transformPaginationToSearchParams(pagination)
  });

/* **** GET **** /user-library/assign */
export const addMymeToLibrary = async (reqBody: POSTAddMymeToLibraryReqBody) =>
  sendRequest<POSTAddMymeToLibraryResponse, typeof reqBody>(addMymeToLibraryAPI, { reqBody });

export const getMymeParticipation = async (mymeId: string) => {
  const response = await sendRequest<MymeParticipation, null>(getMymeParticipationAPI, {
    args: [getMymeIdRecord(mymeId)]
  });
  return {
    ...response,
    data: {
      ...response.data,
      modules: response.data.modules.map(module => ({
        ...module,
        blobs: module.blobs.map(blob => ({
          ...blob,
          location: {
            ...blob?.location,
            latitude: blob?.location?.latitude ? Number(blob?.location?.latitude) : 0,
            longitude: blob?.location?.latitude ? Number(blob?.location?.longitude) : 0
          }
        }))
      }))
    }
  };
};

export const getMymeTableOfContents = async (mymeId: string) =>
  sendRequest<GETMymeTableOfContents, null>(getMymeParticipationAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

export const searchLibraryMymes = async (params: GETLibrarySearchParams, pagination: Pagination) =>
  sendRequest<GETLibraryMymesResponse, null>(searchLibraryMymesAPI, {
    queryStringParams: [
      ...transformPaginationToSearchParams(pagination),
      { key: 'searchQuery', value: params.searchQuery },
      ...transformArrayToSearchParams('categoryIds', params.categoryIds),
      ...transformArrayToSearchParams('types', params.types)
    ]
  });

export const markMymeAsOpened = async (mymeId: UUID) => {
  sendRequest<POSTMarkMymeAsOpenedResponse, null>(markMymeAsOpenedAPI, {
    args: [getMymeIdRecord(mymeId)]
  });
};
